<div id="welcome-wrapper">
  <ng-container *ngIf="user">
    <ng-container *ngIf="!user.phoneConfirmed">
      <h1 mat-dialog-title>
        {{
          ("weNeedSomeData" | i18n) || "Wir benötigen noch einige Daten von dir"
        }}
      </h1>
      <mat-vertical-stepper
        #stepper
        [linear]="true">
        <mat-step
          [completed]="
            user.sex !== undefined && !!user.firstName && !!user.lastName
          ">
          <form (ngSubmit)="submitNameStep()">
            <ng-template matStepLabel>{{
              ("personalInfoHelpText" | i18n) || "Geschlecht und Name"
            }}</ng-template>
            <mat-form-field>
              <mat-label>{{ ("sex" | i18n) || "sex" | titlecase }}</mat-label>
              <mat-select
                [(ngModel)]="user.sex"
                required
                name="sex">
                <mat-option [value]="sexEnum.FEMALE">{{
                  ("femaleSex" | i18n) || "female" | titlecase
                }}</mat-option>
                <mat-option [value]="sexEnum.MALE">{{
                  ("maleSex" | i18n) || "male" | titlecase
                }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ ("firstName" | i18n) || "Vorname" }}</mat-label>
              <input
                matInput
                [(ngModel)]="user.firstName"
                type="text"
                autofocus
                required
                name="firstName"
                autocomplete="firstName" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ ("lastName" | i18n) || "Nachname" }}</mat-label>
              <input
                matInput
                [(ngModel)]="user.lastName"
                type="text"
                autofocus
                required
                name="lastName"
                autocomplete="lastName" />
            </mat-form-field>
            <button
              mat-button
              color="primary"
              type="submit"
              class="mat-button-block">
              {{ ("continue" | i18n) || "Weiter" | titlecase }}
            </button>
          </form>
        </mat-step>
        <mat-step [completed]="!!user.phone">
          <form (ngSubmit)="submitPhoneStep()">
            <ng-template matStepLabel>{{
              ("mobilePhoneNumber" | i18n) || "Handynummer"
            }}</ng-template>
            <mat-form-field>
              <mat-label>{{
                ("mobilePhoneExample" | i18n) ||
                  "Handynummer (z.B. +41791234567)"
              }}</mat-label>
              <input
                matInput
                [(ngModel)]="user.phone"
                type="phone"
                autofocus
                required
                name="phone"
                (keyup)="trimPhone()"
                autocomplete="phone" />
            </mat-form-field>
            <button
              mat-button
              color="primary"
              type="submit"
              class="mat-button-block">
              {{ ("continue" | i18n) || "Weiter" | titlecase }}
            </button>
          </form>
        </mat-step>
        <mat-step>
          <form (ngSubmit)="submitConfirmStep()">
            <ng-template matStepLabel>Verifizierung</ng-template>
            <mat-form-field>
              <mat-label>{{
                ("smsConfirmationCode" | i18n) || "SMS-Bestätigungscode"
              }}</mat-label>
              <input
                matInput
                [(ngModel)]="confirmationCode"
                type="text"
                autofocus
                name="confirmationCode"
                autocomplete="confirmationCode" />
            </mat-form-field>
            <button
              mat-button
              name="resendSmsCode"
              class="mat-button-block mb-4"
              type="button"
              [disabled]="justClickedResendSms"
              (click)="sendNewPhoneToken()">
              {{
                ("resendSmsCode" | i18n) || "SMS-Code erneut anfordern"
                  | titlecase
              }}
            </button>
            <button
              mat-button
              [disabled]="user?.phoneConfirmed"
              color="primary"
              type="submit"
              class="mat-button-block">
              {{ ("continue" | i18n) || "Weiter" | titlecase }}
            </button>
          </form>
        </mat-step>
      </mat-vertical-stepper>
    </ng-container>
    <ng-container *ngIf="!user.emailConfirmed && user.phoneConfirmed">
      <h1 mat-dialog-title>
        {{ ("confirmEmail" | i18n) || "E-Mail-Adresse bestätigen" }}
      </h1>
      <p>
        {{
          ("pleaseConfirmEmail" | i18n) ||
            "Bitte bestätigen Sie die neue E-Mail Adresse mit dem Bestätigungslink, welchen wir Ihnen zugestellt haben"
        }}
      </p>
      <button
        mat-button
        name="resendEmailCode"
        class="mb-4"
        type="button"
        color="primary"
        [disabled]="justClickedResendEmail"
        (click)="sendNewEmailToken()">
        {{
          ("resendConfirmationEmail" | i18n) ||
            "Bestätigungs E-Mail erneut anfordern" | titlecase
        }}
      </button>
    </ng-container>
  </ng-container>
</div>
